import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import { SocietyCorporateId } from 'types/Society';
import operationTypes from 'constants/operationTypes';

import NotarySection from 'modules/_shared/components/NotarySection';
import InputDate from 'modules/_shared/components/InputDate';
import InputTextArea from 'modules/_shared/components/InputTextArea';
import UploadDocument from 'modules/documents/components/UploadDocument';

import { useSharesTransferModal } from '../context/SharesTransferModalContext';

const SharesTransferScriptureView: FC = () => {
  const { t } = useTranslate();
  const animatedComponents = makeAnimated();

  const { data, actions } = useSharesTransferModal();

  const isPlatformAXA =
    process.env.REACT_APP_UI_CORPORATE_ID === SocietyCorporateId.AXA;

  const isTransmission = data.operationType === operationTypes.TRANSMISSION;

  const showAlias = isPlatformAXA && isTransmission;

  return (
    <>
      <InputDate
        id="date"
        label={t('Date')}
        value={data.date || ''}
        onChange={actions.handleChangeDate}
        minDate={data.lastOperationDate}
        errorMessageKey="InvalidOperationDate"
        required
        lgSize
      />

      <UploadDocument
        label="AddDocumentOptional"
        inputLabel={data.file?.name || t('DragDocumentToUpload')}
        file={data.file}
        setFile={actions.handleChangeFile}
      />

      <InputTextArea
        id="comments"
        label={t('CommentsLabel')}
        value={data.comments}
        onChange={actions.handleChangeComments}
        noResize
      />

      <div className="row mb-4">
        <NotarySection
          notaryName={data.notaryName}
          onChangeName={actions.onChangeNotaryName}
          notaryProtocol={data.notaryProtocol}
          onChangeProtocol={actions.onChangeNotaryProtocol}
          notaryCity={data.notaryCity}
          onChangeCity={actions.onChangeNotaryCity}
          lgSize
        />
      </div>

      {showAlias && (
        <div className="form-group">
          <label className="form-label" htmlFor="alia">
            {t('Alias')}
          </label>
          <div className="form-control-wrap">
            <Select
              id="alias"
              closeMenuOnSelect
              className="react-select react-select-lg"
              options={data.aliasOptions}
              components={animatedComponents}
              placeholder={t('SelectAlias')}
              onChange={actions.handleChangeAlias}
              isClearable
              isMulti={false}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SharesTransferScriptureView;
